       (function(window, factory) {
         if (typeof exports === 'object') {
           module.exports = factory();
         } else if (typeof define === 'function' && define.amd) {
           define(factory);
         } else {
           window.eventUtil = factory();
         }
       })(this, function() {
         var hasOwnProperty = Object.prototype.hasOwnProperty;
         var JSBridge = window.JSBridge || (window.JSBridge = {});
         //jsbridge协议定义的名称
         var CUSTOM_PROTOCOL_SCHEME = 'FQ-SMGFSQ-JSBridge';
         //var CUSTOM_PROTOCOL_SCHEME = 'http';
         //最外层的api名称
         var API_Name = 'app_bridge';
         //进行url scheme传值的iframe
         var messagingIframe = document.createElement('iframe');
         messagingIframe.style.display = 'none';
         messagingIframe.src = CUSTOM_PROTOCOL_SCHEME + '://' + API_Name;

         // var messagingIframeHead = document.createElement('head');
         // var messagingIframeHeadBase = document.createElement('base');
         // messagingIframeHeadBase.target='_top';
         // messagingIframe.appendChild(messagingIframeHead.appendChild(messagingIframeHeadBase));
         document.documentElement.appendChild(messagingIframe);

         //定义的回调函数集合,在原生调用完对应的方法后,会执行对应的回调函数id
         var responseCallbacks = {};
         //唯一id,用来确保每一个回调函数的唯一性
         var uniqueId = 1;
         //本地注册的方法集合,原生只能调用本地注册的方法,否则会提示错误
         var messageHandlers = {};
         //当原生调用H5注册的方法时,通过回调来调用(也就是变为了异步执行,加强安全性)
         var dispatchMessagesWithTimeoutSafety = true;
         //本地运行中的方法队列
         var sendMessageQueue = [];

         //实际暴露给原生调用的对象
         var Inner = {
           /**
            * @description 注册本地JS方法通过JSBridge给原生调用
            * 我们规定,原生必须通过JSBridge来调用H5的方法
            * 注意,这里一般对本地函数有一些要求,要求第一个参数是data,第二个参数是callback
            * @param {String} handlerName 方法名
            * @param {Function} handler 对应的方法
            */
           registerHandler: function(handlerName, handler) {
             console.log('register-h5 ' + handlerName);
             messageHandlers[handlerName] = handler;
           },
           /**
            * @description 调用原生开放的方法
            * @param {String} handlerName 方法名
            * @param {JSON} data 参数
            * @param {Function} callback 回调函数
            */
           callHandler: function(handlerName, data, callback) {
             console.log('call-native ' + handlerName);
             //如果没有 data
             if (arguments.length == 3 && typeof data == 'function') {
               callback = data;
               data = null;
             }
             _doSend({
               handlerName: handlerName,
               data: data
             }, callback);
           },
           /**
            * iOS专用
            * @description 当本地调用了callHandler之后,实际是调用了通用的scheme,通知原生
            * 然后原生通过调用这个方法来获知当前正在调用的方法队列
            */
           _fetchQueue: function() {
             var messageQueueString = JSON.stringify(sendMessageQueue);
             sendMessageQueue = [];
             return messageQueueString;
           },
           /**
            * @description 原生调用H5页面注册的方法,或者调用回调方法
            * @param {String} messageJSON 对应的方法的详情,需要手动转为json
            */
           _handleMessageFromNative: function(messageJSON) {
             setTimeout(_doDispatchMessageFromNative);
             /**
              * @description 处理原生过来的方法
              */
             function _doDispatchMessageFromNative() {
               var message;
               try {
                 message = JSON.parse(messageJSON);
               } catch (e) {
                 //TODO handle the exception
                 console.error("原生调用H5方法出错,传入参数错误");
                 return;
               }

               //回调函数
               var responseCallback;
               if (message.responseId) {
                 //这里规定,原生执行方法完毕后准备通知h5执行回调时,回调函数id是responseId
                 responseCallback = responseCallbacks[message.responseId];
                 if (!responseCallback) {
                   return;
                 }
                 //执行本地的回调函数
                 responseCallback(message.responseData);
                 delete responseCallbacks[message.responseId];
               } else {
                 //否则,代表原生主动执行h5本地的函数
                 if (message.callbackId) {
                   //先判断是否需要本地H5执行回调函数
                   //如果需要本地函数执行回调通知原生,那么在本地注册回调函数,然后再调用原生
                   //回调数据有h5函数执行完毕后传入
                   var callbackResponseId = message.callbackId;
                   responseCallback = function(responseData) {
                     //默认是调用EJS api上面的函数
                     //然后接下来原生知道scheme被调用后主动获取这个信息
                     //所以原生这时候应该会进行判断,判断对于函数是否成功执行,并接收数据
                     //这时候通讯完毕(由于h5不会对回调添加回调,所以接下来没有通信了)
                     _doSend({
                       handlerName: message.handlerName,
                       responseId: callbackResponseId,
                       responseData: responseData
                     });
                   };
                 }

                 //从本地注册的函数中获取
                 var handler = messageHandlers[message.handlerName];
                 if (!handler) {
                   //本地没有注册这个函数
                   console.log('你tm没注册! 调用个鸡巴!');
                 } else {
                   //执行本地函数,按照要求传入数据和回调
                   handler(message.data, responseCallback);
                 }
               }
             }
           }

         };
         /**
          * @description JS调用原生方法前,会先send到这里进行处理
          * @param {JSON} message 调用的方法详情,包括方法名,参数
          * @param {Function} responseCallback 调用完方法后的回调
          */
         function _doSend(message, responseCallback) {
           if (responseCallback) {
             //取到一个唯一的callbackid
             var callbackId = Util.getCallbackId();
             //回调函数添加到集合中
             responseCallbacks[callbackId] = responseCallback;
             //方法的详情添加回调函数的关键标识
             message['callbackId'] = callbackId;
           }
           var uri;
           //android中,可以通过onJsPrompt或者截取Url访问都行
           var ua = navigator.userAgent;
           if (ua.match(/(iPhone\sOS)\s([\d_]+)/) || ua.match(/(iPad).*OS\s([\d_]+)/)) {
             //ios中,通过截取客户端url访问
             //因为ios可以不暴露scheme,而是由原生手动获取
             //正在调用的方法详情添加进入消息队列中,原生会主动获取
             sendMessageQueue.push(message);
             uri = Util.getUri();
           } else {
             //android中兼容处理,将所有的参数一起拼接到url中
             uri = Util.getUri(message);
           }
           //获取 触发方法的url scheme
           //采用iframe跳转scheme的方法
           messagingIframe.src = uri;
         }

         var Util = {
           getCallbackId: function() {
             //如果无法解析端口,可以换为Math.floor(Math.random() * (1 << 30));
             return 'cb_' + (uniqueId++) + '_' + new Date().getTime();
           },
           //获取url scheme
           //第二个参数是兼容android中的做法
           //android中由于原生不能获取JS函数的返回值,所以得通过协议传输
           getUri: function(message) {
             var uri = CUSTOM_PROTOCOL_SCHEME + '://' + API_Name;
             if (message) {
               //回调id作为端口存在
               var callbackId, method, params;
               if (message.callbackId) {
                 //第一种:h5主动调用原生
                 callbackId = message.callbackId;
                 method = message.handlerName;
                 params = message.data;
               } else if (message.responseId) {
                 //第二种:原生调用h5后,h5回调
                 //这种情况下需要原生自行分析传过去的port是否是它定义的回调
                 callbackId = message.responseId;
                 method = message.handlerName;
                 params = message.responseData;
               }
               //参数转为字符串
               params = this.getParam(params);
               //uri 补充
               uri += ':' + callbackId + '/' + method + '?' + params;
             }

             return uri;
           },
           getParam: function(obj) {
             if (obj && typeof obj === 'object') {
               return JSON.stringify(obj);
             } else {
               return obj || '';
             }
           }
         };
         for (var key in Inner) {
           if (!hasOwnProperty.call(JSBridge, key)) {
             JSBridge[key] = Inner[key];
           }
         }

         //注册一个测试函数
         // JSBridge.registerHandler('testH5Func', function(data, callback) {
         //  alert('测试函数接收到数据:' + JSON.stringify(data));
         //  callback && callback('测试回传数据...');
         // });
         /*
          ***************************API********************************************
          * 开放给外界调用的api
          * */
         window.smgfsq = {};
         /**
          ***app 模块 
          * 一些特殊操作
          */
         smgfsq = {
           //web组调用SDK
           initShareConfig: function(shareInfo) {
             console.log('call jsbridge');
             var config = arguments[2] ? arguments[2] : {};
             var callback = arguments[1] ? arguments[1] : {};
             //调用设置分享信息
             JSBridge.callHandler('initShareConfig', {
               'shareInfo': {
                 'title': (shareInfo.title && shareInfo.title != '') ? shareInfo.title : '',
                 'desc': (shareInfo.desc && shareInfo.desc != '') ? shareInfo.desc : '',
                 'link': (shareInfo.link && shareInfo.link != '') ? shareInfo.link : '',
                 'imgUrl': (shareInfo.imgUrl && shareInfo.imgUrl != '') ? shareInfo.imgUrl : ''
               },
               'config': {
                 'menu': (typeof config.menu != 'undefined' && config.menu !== '') ? config.menu : 1, //是否开启菜单
                 'sina': (typeof config.sina != 'undefined' && config.sina !== '') ? config.sina : 1, //是否允许分享到新浪
                 'qq': (typeof config.qq != 'undefined' && config.qq !== '') ? config.qq : 1, //是否允许分享到QQ
                 'qZone': (typeof config.qZone != 'undefined' && config.qZone !== '') ? config.qZone : 1, //是否允许分享到Q空间
                 'weChat': (typeof config.weChat != 'undefined' && config.weChat !== '') ? config.weChat : 1, //是否允许分享到微信
                 'weMoments': (typeof config.weMoments != 'undefined' && config.weMoments !== '')? config.weMoments : 1, //是否允许分享到微信朋友圈
                 'refresh': (typeof config.refresh != 'undefined' && config.refresh !== '') ? config.refresh : 1, //是否允许刷新
                 'copy': (typeof config.copy != 'undefined' && config.copy !== '') ? config.copy : 1, //是否允许复制链接
                 'browser': (typeof config.browser != 'undefined' && config.browser !== '') ? config.browser : 1 //是否允许浏览器打开
               }
             }, function(res) {
               callback && callback(res);
             });
           },
           //以下为内部H5使用
           //告知分享信息
           H2N_initShareConfig: function(config, shareInfo = {}, callback = {}) {
             //调用设置分享信息
             JSBridge.callHandler('initShareConfig', {
               'config': {
                 'menu': (typeof config.menu != 'undefined' && config.menu !== '') ? config.menu : 0, //是否开启菜单
                 'sina': (typeof config.sina != 'undefined' && config.sina !== '') ? config.sina : 0, //是否允许分享到新浪
                 'qq': (typeof config.qq != 'undefined' && config.qq !== '') ? config.qq : 0, //是否允许分享到QQ
                 'qZone': (typeof config.qZone != 'undefined' && config.qZone !== '') ? config.qZone : 0, //是否允许分享到Q空间
                 'weChat': (typeof config.weChat != 'undefined' && config.weChat !== '') ? config.weChat : 0, //是否允许分享到微信
                 'weMoments': (typeof config.weMoments != 'undefined' && config.weMoments !== '')? config.weMoments : 0, //是否允许分享到微信朋友圈
                 'refresh': (typeof config.refresh != 'undefined' && config.refresh !== '') ? config.refresh : 0, //是否允许刷新
                 'copy': (typeof config.copy != 'undefined' && config.copy !== '') ? config.copy : 0, //是否允许复制链接
                 'browser': (typeof config.browser != 'undefined' && config.browser !== '') ? config.browser : 0 //是否允许浏览器打开
               },
               'shareInfo': {
                 'title': (shareInfo.title && shareInfo.title != '') ? shareInfo.title : '',
                 'desc': (shareInfo.desc && shareInfo.desc != '') ? shareInfo.desc : '',
                 'link': (shareInfo.link && shareInfo.link != '') ? shareInfo.link : '',
                 'imgUrl': (shareInfo.imgUrl && shareInfo.imgUrl != '') ? shareInfo.imgUrl : '',
               }
             }, function(res) {
               callback && callback(res);
             });
           },
           H2N_login: function(callback = '') {
             //调用设置分享信息
             JSBridge.callHandler('login', {
               'callback': callback
             }, function(res) {
               callback && callback(res);
             });
           },
           N2H_hasShare(callbackFunc) {
             JSBridge.registerHandler('hasShare', function(data, callback) {
               console.log('answer-native HasShare');
               console.log('测试函数接收到数据:' + JSON.stringify(data));
               callbackFunc && callbackFunc();
             });
           }
         };
       });

       // smgfsq.api.H2N_initShareConfig({
       //          'title': '标题测试',
       //          'desc': '描述测试',
       //          'link': 'http://devh5.sns.founq.com/activity/lottery',
       //          'imgUrl': 'http://founq-shumen.oss-cn-shanghai.aliyuncs.com/88/gm.png'
       //      });


// WEBPACK FOOTER //
// ./src/vendor/jsBridge/sdk.js?t=1